/* eslint-disable no-console */
export const renderTicks: (value: number) => number = (value) => {
  if (value === 0) {
    return 0;
  } else {
    return `${value}`.includes('.')
      ? value <= 1
        ? Number(value.toFixed(2))
        : Number((Math.round(value * 4) / 4).toFixed(0))
      : value <= 1
        ? value
        : Math.trunc(value);
  }
};

export const divideIntoSixParts = (
  total: number,
  divideBy: number = 5
): number[] => {
  const parts = [];
  const increment = total / divideBy;
  if (total) {
    for (let i = 0; i <= divideBy; i++) {
      parts.push(renderTicks(i * increment));
    }
  }

  return parts;
};
